<!--
  LINE menu background (1472x150): an aurora-night panorama. The whole sky,   dark teal night, stars, the pink horizon glow and the sweeping aurora
  ribbons, is painted inside a mask that is alpha-0 above y=16, so the top
  edge is GUARANTEED fully transparent, blur included. Mountains (theme
  window/editor backgrounds) with sparse pines sit in front; a flat dark plain
  grounds the tab icons. Everything tiles seamlessly left-right (LINE repeats
  this strip): ribbons taper to nothing at the seam, every horizontal
  gradient's first and last stops are identical, trees never touch the edges.
-->
<svg class="menu-bg" *ngIf="design === 'aurora'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Alpha ramp for the sky mask: fully clear above y=16, solid by y=46.
         LINE spec (Images 1.1): the BOTTOM 100px of i_11 must be fully opaque,
         so on a 150px strip the ramp has to finish at or above y=50 — y=46
         keeps a few px of margin for renderer antialiasing. -->
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>

    <!-- Dark teal night-sky shading. -->
    <linearGradient [attr.id]="uid + '-sky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="18" x2="0" y2="120">
      <stop offset="0" [attr.stop-color]="skyTop"></stop>
      <stop offset="0.55" [attr.stop-color]="skyMid"></stop>
      <stop offset="1" [attr.stop-color]="skyLow"></stop>
    </linearGradient>

    <!-- Pink aurora glow pooling on the horizon (edge stops match = tiles). -->
    <linearGradient [attr.id]="uid + '-pinkband'" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" [attr.stop-color]="horizonPink" stop-opacity="0.14"></stop>
      <stop offset="0.45" [attr.stop-color]="horizonPink" stop-opacity="0.34"></stop>
      <stop offset="0.72" [attr.stop-color]="horizonPink" stop-opacity="0.22"></stop>
      <stop offset="1" [attr.stop-color]="horizonPink" stop-opacity="0.14"></stop>
    </linearGradient>

    <!-- Per-ribbon horizontal intensity sweep (colour constant, opacity
         varies; both edge stops are 0, so the arc dies before the seam).
         Two gradients per ribbon: the halo colour and the brighter core. -->
    <ng-container *ngFor="let r of ribbons">
      <linearGradient [attr.id]="r.gradId" x1="0" y1="0" x2="1" y2="0">
        <stop *ngFor="let s of r.stops" [attr.offset]="s.off"
              [attr.stop-color]="r.color" [attr.stop-opacity]="s.o"></stop>
      </linearGradient>
      <linearGradient [attr.id]="r.gradId + '-core'" x1="0" y1="0" x2="1" y2="0">
        <stop *ngFor="let s of r.stops" [attr.offset]="s.off"
              [attr.stop-color]="r.coreColor" [attr.stop-opacity]="s.o"></stop>
      </linearGradient>
    </ng-container>

    <filter [attr.id]="uid + '-halo'" x="-10%" y="-60%" width="120%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <filter [attr.id]="uid + '-body'" x="-10%" y="-60%" width="120%" height="220%">
      <feGaussianBlur stdDeviation="2"></feGaussianBlur>
    </filter>
    <filter [attr.id]="uid + '-fine'" x="-10%" y="-60%" width="120%" height="220%">
      <feGaussianBlur stdDeviation="0.9"></feGaussianBlur>
    </filter>
    <filter [attr.id]="uid + '-pool'" x="-30%" y="-120%" width="160%" height="340%">
      <feGaussianBlur stdDeviation="12"></feGaussianBlur>
    </filter>
  </defs>

  <!-- The whole sky lives under the top-transparency mask. -->
  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="16" [attr.width]="W" [attr.height]="H - 16" [attr.fill]="'url(#' + uid + '-sky)'"></rect>

    <!-- Stars (behind the aurora). -->
    <circle *ngFor="let s of stars" [attr.cx]="s.x" [attr.cy]="s.y"
            [attr.r]="s.r" fill="#EAF6FF" [attr.opacity]="s.o"></circle>

    <!-- Pink glow pooling on the horizon, strongest centre-left of the pink zone. -->
    <rect x="0" y="92" [attr.width]="W" height="34"
          [attr.fill]="'url(#' + uid + '-pinkband)'" [attr.filter]="'url(#' + uid + '-pool)'"></rect>

    <!-- Sweeping aurora ribbons: blurred halo, bright body, crisp top rim,          all swept by the ribbon's own intensity gradient. -->
    <ng-container *ngFor="let r of ribbons">
      <path [attr.d]="r.glow" [attr.fill]="'url(#' + r.gradId + ')'"
            [attr.filter]="'url(#' + uid + '-halo)'"></path>
      <path [attr.d]="r.core" [attr.fill]="'url(#' + r.gradId + '-core)'"
            [attr.filter]="'url(#' + uid + '-body)'"></path>
      <path [attr.d]="r.crest" fill="none" [attr.stroke]="'url(#' + r.gradId + '-core)'"
            stroke-width="1.6" [attr.filter]="'url(#' + uid + '-fine)'"></path>
    </ng-container>
  </g>

  <!-- Mountain layers back -> front (window/editor background colours),
       each with its sparse pine forest. -->
  <ng-container *ngFor="let g of ridges">
    <path [attr.d]="g.d" [attr.fill]="g.fill" [attr.fill-opacity]="g.opacity"></path>
    <path *ngIf="g.treeD" [attr.d]="g.treeD" [attr.fill]="g.fill" [attr.fill-opacity]="g.opacity"></path>
  </ng-container>
</svg>

<!--
  AUTUMN (kawaii "fall"): Everest's daylight structure in the theme's oranges —
  a pale warm sky, soft round canopies instead of peaks, a few of the theme's own
  maple leaves drifting where Everest puts sparkles, and a rolling ground. Same
  top-transparency mask (clear above y=16, solid by y=46) and tiling rules.
-->
<svg class="menu-bg" *ngIf="design === 'fall'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-fallsky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="auSkyTopF"></stop>
      <stop offset="1" [attr.stop-color]="auSkyLowF"></stop>
    </linearGradient>
    <!--
      The soil. Its LAST stop is the tab bar's own fill, so the strip ends on
      exactly the colour LINE paints below it and the 150px edge disappears.
    -->
    <linearGradient [attr.id]="uid + '-fallsoil'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="122" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="fallSoilTop"></stop>
      <stop offset="1" [attr.stop-color]="fallSoilLow"></stop>
    </linearGradient>
    <!--
      The treeline's haze. The crowns are big enough now to reach into the band
      the five tab glyphs occupy (about y=30..110), so the canopies fade out
      upward instead of sitting flat behind the icons: full strength where they
      meet the soil, a quarter of it up where the glyphs are. Reads as morning
      haze, and keeps the icons legible without shrinking the trees.
    -->
    <linearGradient [attr.id]="uid + '-falltreeramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="40" x2="0" y2="118">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0.55"></stop>
      <stop offset="0.5" stop-color="#ffffff" stop-opacity="0.82"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-falltreem'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H"
            [attr.fill]="'url(#' + uid + '-falltreeramp)'"></rect>
    </mask>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-fallsky)'"></rect>

    <!-- drifting maples, up where the sky is empty -->
    <path *ngFor="let l of fallLeaves" [attr.d]="mapleBlade" [attr.transform]="l.transform"
          [attr.fill]="l.fill" [attr.opacity]="l.o"></path>

    <!--
      The treeline: MAPLES. Each crown is a rosette of the theme's own maple
      leaf, so the silhouette's edge is made of real lobes and sinuses — the one
      thing that says maple rather than "a tree" (owner 2026-08-13). Opacity goes
      on the GROUP, never on the individual leaves, or every overlap would darken
      and the crown would read as a pile instead of one canopy.
    -->
    <g [attr.mask]="'url(#' + uid + '-falltreem)'">
      <g *ngFor="let t of fallTrees" [attr.opacity]="t.o">
        <path [attr.d]="t.trunk" fill="#B08463"></path>
        <path *ngFor="let tr of t.leaves" [attr.d]="mapleBlade" [attr.transform]="tr"
              [attr.fill]="t.fill"></path>
      </g>
    </g>

    <path [attr.d]="fallGroundD" [attr.fill]="'url(#' + uid + '-fallsoil)'"></path>
  </g>
</svg>

<!--
  MIAMI (1472x150): a neon skyline at sunset over the bay, from the theme's own
  icon. Violet-to-coral dusk, the sun sitting on the waterline, two rows of
  towers with lit windows, the bay carrying the sun's broken reflection, and
  palms on the near shore.

  Tiling is solved per layer (see buildMiami): sky and sea are flat gradients so
  they cannot seam, the shore is an integer-frequency sine, and every tower that
  crosses the right edge is drawn again a full width to the left. The same top
  alpha ramp as every other design — clear above y=16, solid by y=46, which
  satisfies LINE's "bottom 100px fully opaque" rule with margin.
-->
<svg class="menu-bg" *ngIf="design === 'miami'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-misky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="34" x2="0" y2="126">
      <stop offset="0" [attr.stop-color]="miSkyTop"></stop>
      <stop offset="0.6" [attr.stop-color]="miSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="miSkyLow"></stop>
    </linearGradient>
    <!-- The bay's ramp. It finishes at y=138, not 150: the bottom ROW is y=149
         and is sampled at its centre, so a ramp ending at the edge never quite
         reaches its last stop and the exported row comes out a digit off the tab
         bar's colour. -->
    <linearGradient [attr.id]="uid + '-misea'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="126" x2="0" y2="146">
      <stop offset="0" [attr.stop-color]="miSeaDeep"></stop>
      <stop offset="1" [attr.stop-color]="miSeaFill"></stop>
    </linearGradient>
    <clipPath [attr.id]="uid + '-misunclip'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="miSunClip"></rect>
    </clipPath>
    <radialGradient [attr.id]="uid + '-miglow'">
      <stop offset="0" [attr.stop-color]="miGlowFill" stop-opacity="0.7"></stop>
      <stop offset="1" [attr.stop-color]="miGlowFill" stop-opacity="0"></stop>
    </radialGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-misky)'"></rect>

    <!-- The sun and its warmth. A radial GRADIENT, never a blur filter: a blur
         reaching an edge fades there and bakes a dark stripe into the seam. -->
    <circle [attr.cx]="miSun.cx" [attr.cy]="miSun.cy" [attr.r]="miSun.r * 3.4"
            [attr.fill]="'url(#' + uid + '-miglow)'"></circle>
    <!-- The DISC is clipped at the city's footing so it sets behind the land.
         The GLOW is not: it is soft and warm, and cutting it would put a straight
         edge across the haze. -->
    <circle [attr.cx]="miSun.cx" [attr.cy]="miSun.cy" [attr.r]="miSun.r"
            [attr.clip-path]="'url(#' + uid + '-misunclip)'"
            [attr.fill]="miSunFill" opacity="0.95"></circle>

    <!-- far towers, then near towers over them -->
    <rect *ngFor="let b of miFar" [attr.x]="b.x" [attr.y]="b.y" [attr.width]="b.w"
          [attr.height]="b.h" [attr.fill]="miFarFill" opacity="0.72"></rect>
    <rect *ngFor="let b of miNear" [attr.x]="b.x" [attr.y]="b.y" [attr.width]="b.w"
          [attr.height]="b.h" [attr.fill]="miNearFill"></rect>
    <rect *ngFor="let w of miWindows" [attr.x]="w.x" [attr.y]="w.y" [attr.width]="w.w"
          [attr.height]="w.h" [attr.fill]="miWindowFill" opacity="0.85"></rect>

    <!-- The bay: one sheet in the tab bar's own colour, so the strip's bottom
         edge disappears into what LINE paints below it. The sun's reflection
         breaks up across it. -->
    <rect x="0" [attr.y]="miSeaTop" [attr.width]="W" [attr.height]="H - miSeaTop"
          [attr.fill]="'url(#' + uid + '-misea)'"></rect>
    <rect *ngFor="let s of miStreaks" [attr.x]="s.x" [attr.y]="s.y" [attr.width]="s.w"
          [attr.height]="s.h" rx="1" [attr.fill]="miStreakFill" [attr.opacity]="s.o"></rect>
  </g>
</svg>

<!--
  ISTANBUL: the Bosphorus at first light. A cool sky held at ONE mid tone across
  the icon band (the theme's LINE skin is light and its tab fill #4AC3E0 is what
  the glyphs were chosen against, so the strip stays near that value rather than
  going pale or dark under them), the warm dawn haze pooled down on the far
  shore, the old city's domes and minarets standing in it, and the strait in
  front landing on exactly lineTabFill('istanbul').

  Tiling: sky, haze and water are vertical gradients, uniform in x; the
  waterfront is a sum of integer-frequency sines, periodic in value AND slope;
  every drawn object stays well inside both edges, so the seam falls in open
  sky, flat shoreline and open water. Same top alpha ramp as every other design
  — clear above y=16, solid by y=46, which satisfies LINE's "bottom 100px fully
  opaque" rule with margin.
-->
<svg class="menu-bg" *ngIf="design === 'istanbul'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>

    <linearGradient [attr.id]="uid + '-issky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="118">
      <stop offset="0" [attr.stop-color]="isSkyTop"></stop>
      <stop offset="0.5" [attr.stop-color]="isSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="isSkyLow"></stop>
    </linearGradient>

    <!-- First light behind the shore. A radial GRADIENT on an ellipse, never a
         blur filter: a blur reaching an edge fades there and bakes a stripe
         into the tile seam. -->
    <radialGradient [attr.id]="uid + '-isglow'">
      <stop offset="0" [attr.stop-color]="isGlowFill" stop-opacity="0.85"></stop>
      <stop offset="0.5" [attr.stop-color]="isGlowFill" stop-opacity="0.34"></stop>
      <stop offset="1" [attr.stop-color]="isGlowFill" stop-opacity="0"></stop>
    </radialGradient>

    <!-- The dawn haze: zero at isHazeTop, full only down on the shore. -->
    <linearGradient [attr.id]="uid + '-ishaze'" gradientUnits="userSpaceOnUse"
                    x1="0" [attr.y1]="isHazeTop" x2="0" [attr.y2]="isWaterTop + 1">
      <stop offset="0" [attr.stop-color]="isHazeFill" stop-opacity="0"></stop>
      <stop offset="0.55" [attr.stop-color]="isHazeFill" [attr.stop-opacity]="isHazeMax * 0.42"></stop>
      <stop offset="1" [attr.stop-color]="isHazeFill" [attr.stop-opacity]="isHazeMax"></stop>
    </linearGradient>

    <!-- The strait. Its LAST stop is the tab bar's own fill, and the ramp closes
         at y=148 rather than 150: the bottom ROW is y=149, sampled at its
         centre, so a ramp ending at the edge never quite reaches its last stop
         and the exported row lands a digit off the bar's colour. -->
    <!-- The land is drawn a SECOND time on top of the bridge, clipped to the
         waterline, so the span's ends disappear behind the headlands instead of
         stopping in mid-air (owner 2026-08-14: "sol ve sağdaki topraklar
         köprünün üzerinde olsun z indexinde, böylece köprünün sonları boşta
         gözükmez"). Clipped rather than redrawn short, because the shore path
         fills all the way down and an unclipped copy would bury the strait. -->
    <clipPath [attr.id]="uid + '-island'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="isWaterTop + 1"></rect>
    </clipPath>

    <linearGradient [attr.id]="uid + '-iswater'" gradientUnits="userSpaceOnUse"
                    x1="0" [attr.y1]="isWaterTop" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="isWaterDeep"></stop>
      <stop offset="0.5" [attr.stop-color]="isWaterMid"></stop>
      <stop offset="1" [attr.stop-color]="isWaterLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-issky)'"></rect>

    <!-- the last of the night's moon -->
    <path *ngIf="isMoonD" [attr.d]="isMoonD" [attr.fill]="isMoonFill" opacity="0.5"></path>

    <!-- first light, then the haze it pools into -->
    <ellipse [attr.cx]="isGlow.cx" [attr.cy]="isGlow.cy" [attr.rx]="isGlow.rx" [attr.ry]="isGlow.ry"
             [attr.fill]="'url(#' + uid + '-isglow)'"></ellipse>
    <rect x="0" [attr.y]="isHazeTop" [attr.width]="W" [attr.height]="isWaterTop + 1 - isHazeTop"
          [attr.fill]="'url(#' + uid + '-ishaze)'"></rect>

    <!-- the old city, four depth steps: roofs, far complexes, near mosques,
         then the waterfront over all of them -->
    <path [attr.d]="isRoofD" [attr.fill]="isRoofFill"></path>
    <path [attr.d]="isFarD" [attr.fill]="isFarFill"></path>
    <path [attr.d]="isNearD" [attr.fill]="isNearFill"></path>
    <path [attr.d]="isShoreD" [attr.fill]="isShoreFill"></path>

    <!-- the strait, the dawn light broken on it, and the ferries -->
    <rect x="0" [attr.y]="isWaterTop" [attr.width]="W" [attr.height]="H - isWaterTop"
          [attr.fill]="'url(#' + uid + '-iswater)'"></rect>
    <rect *ngFor="let g of isGlints" [attr.x]="g.x" [attr.y]="g.y" [attr.width]="g.w"
          [attr.height]="g.h" rx="0.7" [attr.fill]="isGlintFill" [attr.opacity]="g.o"></rect>
    <rect *ngFor="let w of isWakes" [attr.x]="w.x" [attr.y]="w.y" [attr.width]="w.w"
          height="1.2" rx="0.6" [attr.fill]="isWakeFill" [attr.opacity]="w.o"></rect>
    <path *ngFor="let b of isFerries" [attr.d]="b.d" [attr.fill]="b.fill"></path>

    <!-- The Bosphorus bridge, drawn LAST over the water so it crosses in front
         of the ferries and the broken light. The cable is STROKED rather than
         filled: a suspension cable is a line, and a filled outline of one is
         two hairlines that merge into a smudge the moment the strip is
         downscaled. No vertical hangers, which is the icon's own simplification
         (see buildIstanbul). -->
    <path [attr.d]="isCableD" fill="none" [attr.stroke]="isCableFill"
          stroke-width="2.6" stroke-linecap="round"></path>
    <path [attr.d]="isBridgeD" [attr.fill]="isBridgeFill"></path>
    <path [attr.d]="isDeckLineD" fill="none" [attr.stroke]="isDeckLine"
          stroke-width="1.1" opacity="0.9"></path>

    <!-- the two headlands, back over the span's ends -->
    <g [attr.clip-path]="'url(#' + uid + '-island)'">
      <path [attr.d]="isShoreD" [attr.fill]="isShoreFill"></path>
    </g>
  </g>
</svg>

<!--
  PARIS: the Seine at night, seen over a bridge arcade. A plum-black sky with the
  city's glow pooled low on it, the icon's own skyline in silhouette on the far
  bank (Arc de Triomphe, the Eiffel Tower centre and dominant, Notre-Dame, and a
  dome answering them on the right) behind a run of Haussmann mansards, and
  TWELVE arched bays — Pont Neuf's count — carrying the river across the strip.

  The arcade is what makes this one tile: its period is exactly W/12, so the arch
  rhythm continues across the join by construction and the seam falls down the
  centre line of a pier. Same top-transparency mask (clear above y=16, solid by
  y=46) as every other design, and the water ramp closes at y=148 so the bottom
  row lands exactly on the tab bar's own fill.

  PLACEHOLDER SKIN: no LINE colour set has been picked for Paris yet, so every
  skin value — the tab fill above all — is Roraima's, read through lineTabFill()
  and due to be resampled from the owner's device screenshots.
-->
<svg class="menu-bg" *ngIf="design === 'paris'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>

    <linearGradient [attr.id]="uid + '-pasky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" [attr.y2]="paWaterTop + 6">
      <stop offset="0" [attr.stop-color]="paSkyTop"></stop>
      <stop offset="0.52" [attr.stop-color]="paSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="paSkyLow"></stop>
    </linearGradient>

    <!-- The city's glow on the sky, and its pool on the river. Radial
         GRADIENTS, never blur filters: a blur that reaches an edge fades there
         and bakes a stripe into every tile seam. -->
    <radialGradient [attr.id]="uid + '-paglow'">
      <stop offset="0" [attr.stop-color]="paGlowFill" stop-opacity="0.30"></stop>
      <stop offset="0.45" [attr.stop-color]="paGlowFill" stop-opacity="0.14"></stop>
      <stop offset="1" [attr.stop-color]="paGlowFill" stop-opacity="0"></stop>
    </radialGradient>
    <radialGradient [attr.id]="uid + '-pahero'">
      <stop offset="0" [attr.stop-color]="paGlowFill" stop-opacity="0.22"></stop>
      <stop offset="0.5" [attr.stop-color]="paGlowFill" stop-opacity="0.09"></stop>
      <stop offset="1" [attr.stop-color]="paGlowFill" stop-opacity="0"></stop>
    </radialGradient>
    <radialGradient [attr.id]="uid + '-pariver'">
      <stop offset="0" [attr.stop-color]="paGlowFill" stop-opacity="0.34"></stop>
      <stop offset="0.5" [attr.stop-color]="paGlowFill" stop-opacity="0.15"></stop>
      <stop offset="1" [attr.stop-color]="paGlowFill" stop-opacity="0"></stop>
    </radialGradient>
    <radialGradient [attr.id]="uid + '-palamp'">
      <stop offset="0" [attr.stop-color]="paLampFill" stop-opacity="0.34"></stop>
      <stop offset="0.5" [attr.stop-color]="paLampFill" stop-opacity="0.11"></stop>
      <stop offset="1" [attr.stop-color]="paLampFill" stop-opacity="0"></stop>
    </radialGradient>

    <!-- The Seine. Its LAST stop is the tab bar's own fill, and the ramp closes
         at y=148 rather than 150: the bottom ROW is y=149, sampled at its
         centre, so a ramp ending at the edge never quite reaches its last stop
         and the exported row lands a digit off the bar's colour. -->
    <linearGradient [attr.id]="uid + '-pawater'" gradientUnits="userSpaceOnUse"
                    x1="0" [attr.y1]="paWaterTop" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="paWaterDeep"></stop>
      <stop offset="0.55" [attr.stop-color]="paWaterMid"></stop>
      <stop offset="1" [attr.stop-color]="paWaterLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-pasky)'"></rect>

    <!-- stars, up where the sky is empty -->
    <circle *ngFor="let s of paStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
            [attr.fill]="paStarFill" [attr.opacity]="s.o"></circle>

    <!-- the city's light on the sky: dim, and low, so the glyph band above it
         stays the darkest part of the strip. The second, narrower one stands
         behind the Eiffel Tower — without light behind its whole height, no one
         fill silhouettes both against the bright horizon and against the night. -->
    <ellipse [attr.cx]="paGlow.cx" [attr.cy]="paGlow.cy" [attr.rx]="paGlow.rx" [attr.ry]="paGlow.ry"
             [attr.fill]="'url(#' + uid + '-paglow)'"></ellipse>
    <ellipse [attr.cx]="paHeroGlow.cx" [attr.cy]="paHeroGlow.cy"
             [attr.rx]="paHeroGlow.rx" [attr.ry]="paHeroGlow.ry"
             [attr.fill]="'url(#' + uid + '-pahero)'"></ellipse>

    <!-- The terrace, back to front: the mansard roofs and their chimneys first,
         then the stone faces in front of them, then the cornice and balcony
         bands, then the windows cut into the stone. Roofs BEHIND the faces is
         what lets a roof overhang its own wall without a join showing. -->
    <path [attr.d]="paRoofD" [attr.fill]="paRoofFill"></path>
    <path [attr.d]="paCityD" [attr.fill]="paCityFill"></path>
    <path [attr.d]="paHeroD" [attr.fill]="paHeroFill"></path>
    <path [attr.d]="paWindowD" [attr.fill]="paWindowFill" opacity="0.9"></path>

    <!-- the plane trees, in front of the terrace: trunks first, then the crowns
         over them so a crown always overlaps its own trunk cleanly -->
    <path [attr.d]="paTrunkD" [attr.fill]="paTrunkFill"></path>
    <path [attr.d]="paTreeD" [attr.fill]="paTreeFill"></path>

    <!-- the quay the terrace stands on -->
    <path [attr.d]="paQuayD" [attr.fill]="paQuayFill"></path>

    <!-- The Seine. Its last stop IS the tab bar's fill, so the strip and the bar
         meet without an edge. -->
    <rect x="0" [attr.y]="paWaterTop" [attr.width]="W" [attr.height]="H - paWaterTop"
          [attr.fill]="'url(#' + uid + '-pawater)'"></rect>

    <!-- the bridge, in front of the water: deck, piers and segmental arches,
         with a coping hairline along the deck's top edge -->
    <path [attr.d]="paBridgeD" [attr.fill]="paBridgeFill" fill-rule="evenodd"></path>
  </g>
</svg>

<!--
  RORAIMA (kawaii "tepui"): a sunset over the table mountains — the theme's own
  icon opened out. Pale hazy walls receding into a cloud sea, the sun going down
  behind them, and a near bank whose gradient lands exactly on the tab bar's fill
  so the strip has no bottom edge. Same top-transparency mask (clear above y=16,
  solid by y=46) as every other design.
-->
<!--
  RIO: Guanabara Bay at first light. Pale by design — Rio's tab glyphs are deep
  green (its skin is light), and a classic glyph lands right across this
  horizon, so nothing in the icon band may go dark. See buildRio.
-->
<!--
  TALLINN: the old town under snow. Pale by design — a classic glyph lands on
  this sky, so the roofline is held at y 78 and only the tower cones and the
  spire (all in tab gaps) reach above it. See buildTallinn.
-->
<!--
  OCEAN (1472x150): the seabed the theme's icon draws. Dark open water where the
  tab glyphs land (y 13..93), the coral garden and the seagrass rising into the
  TAB GAPS, bioluminescent currents held under 0.22 opacity so they can cross the
  glyph band without competing, bubbles going up in columns off the vents, and a
  lit floor whose ramp ENDS on the tab bar's own fill so the strip has no edge
  under it. Everything inside the alpha mask that is clear above y=16 and fully
  opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  SALDA (1472x150): the white shore and the shallows. Everything above y=92 is
  pale — sky and a low blue-grey range — because this theme's tab glyphs are DARK
  and y 13..93 is where they land; every saturated turquoise lives under that
  line. The BEYAZ ADALAR, the white shoals Salda is known for, stand in the TAB
  GAPS, and the beach ramps into the tab bar's own fill so the sand of the scene
  and the fill of the bar are one surface. Inside the alpha mask that is clear
  above y=16 and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  PRAGUE (1472x150): Hradcany over the Vltava at night. The glyph band (y 13..93)
  is NIGHT SKY, which is the one strip in this family where the constraint and the
  subject want the same thing; the two things that reach up into it — the
  cathedral and the moon — stand in TAB GAPS. The gold is confined to one terrace
  band and a handful of windows, because a skyline with every window lit is a
  hotel. The river ramps into the tab bar's own fill, so the water of the scene
  and the fill of the bar are one surface. All inside the alpha mask that is clear
  above y=16 and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  SYDNEY (1472x150): the harbour at midday. Two thirds sky — blue above, warm at
  the horizon, the icon's own gradient — so the glyph band (y 13..93) is the
  palest thing in the scene and this theme's DARK tab glyphs land on it cleanly.
  The city runs low along the quay, the landmarks stand in the TAB GAPS (the Opera
  House is the theme's own Home glyph), and the water ramps into the tab bar's own
  fill so the harbour and the bar are one surface. All inside the alpha mask that
  is clear above y=16 and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  REYNISFJARA (1472x150): the black beach at DUSK. The icon's near-white overcast
  sky is deliberately not used — see buildReynisfjara for why (the glyph band and
  the dark iOS-26 glass want opposite things from a near-white strip). The last of
  the light lies on the horizon BELOW y=96, so no tab glyph ever has to read
  against it. Basalt in both its forms: the column cliff and the stacks offshore.
  The black sand ramps into the tab bar's own fill. All inside the alpha mask that
  is clear above y=16 and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  SPRING (1472x150): the lupine meadow. Sky and cloud in the glyph band (y 13..93),
  everything with a shape below it — the flower spikes are TALL only in the TAB
  GAPS, so nothing ever grows through the row of tabs. The hummingbird is the
  theme's own Home glyph, hovering in the second gap. The foreground haze ramps
  into the tab bar's own fill. All inside the alpha mask that is clear above y=16
  and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  VIENNA (1472x150): the auditorium — the one INTERIOR in this family. Two tiers of
  gilded box fronts run the length of the strip (an auditorium seen frontally does
  not tile; seen FROM a box it does), the proscenium arch and the chandelier stand
  in TAB GAPS, and the rows of seats in the stalls run into the tab bar's own fill.
  The glyph band (y 13..93) is ceiling and the shadowed openings of the upper tier.
  All inside the alpha mask that is clear above y=16 and fully opaque by y=46 (the
  LINE bottom-100px rule).
-->
<!--
  MADRID (1472x150): Gran Via at sunset. The sun is low and behind the street, so
  the tops of the buildings are lit and the pavement is in shadow — which is the
  picture AND the constraint at once, because this theme's DARK tab glyphs land in
  y 13..93. The domes stand in the TAB GAPS (the first is the Metropolis with its
  winged victory) and the theme's own fan is being carried along the pavement in
  the last one. The street ramps into the tab bar's own fill. All inside the alpha
  mask that is clear above y=16 and fully opaque by y=46 (the LINE bottom-100px
  rule).
-->
<!--
  ETNA (1472x150): the mountain at night. The theme's icon lights its sky from the
  TOP and this inverts it — near-black overhead, heating toward the horizon —
  because the glyph band is y 13..93 and a saturated crimson up there would swallow
  this theme's crimson glyphs. Reynisfjara makes the same move for the same reason:
  both icons are lit from the wrong end for a tab bar, and in both cases the honest
  fix was to change the HOUR rather than the subject. The cone is the theme's own
  Home glyph at landscape scale, standing over a TAB GAP. All inside the alpha mask
  that is clear above y=16 and fully opaque by y=46 (the LINE bottom-100px rule).
-->
<!--
  FUJI (1472x150): the mountain at dawn, and the only strip in this family whose
  constraint cost nothing — the tab glyphs are DARK and the icon is already a
  pastel sky with a pale mountain in it. The sun and the pagoda stand in TAB GAPS.
  There is deliberately NO cherry blossom anywhere in this theme: Sakura is a theme
  in the same set and the blossom is its whole identity. The mist ramps into the
  tab bar's own fill. All inside the alpha mask that is clear above y=16 and fully
  opaque by y=46 (the LINE bottom-100px rule).
-->
<svg class="menu-bg" *ngIf="design === 'fuji'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-fusky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="126">
      <stop offset="0" [attr.stop-color]="fuSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="fuSkyLow"></stop>
    </linearGradient>
    <radialGradient [attr.id]="uid + '-fusun'">
      <stop offset="0" stop-color="#FFE9DE" stop-opacity="0.7"></stop>
      <stop offset="1" stop-color="#FFE9DE" stop-opacity="0"></stop>
    </radialGradient>
    <!-- The mist. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-fumist'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="126" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="fuMistTop"></stop>
      <stop offset="1" [attr.stop-color]="fuMistLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-fusky)'"></rect>

    <!-- the sun, with its halo under it -->
    <circle [attr.cx]="fuSunX" [attr.cy]="fuSunY" [attr.r]="fuSunR * 3"
            [attr.fill]="'url(#' + uid + '-fusun)'"></circle>
    <circle [attr.cx]="fuSunX" [attr.cy]="fuSunY" [attr.r]="fuSunR" fill="#FBC9C0"></circle>

    <!-- the print's flat cloud bands -->
    <path *ngFor="let c of fuClouds" [attr.d]="c.d" [attr.fill]="c.fill"
          [attr.opacity]="c.o"></path>

    <!-- the range, the mountain, the near hills and the pagoda -->
    <path *ngFor="let l of fuLand" [attr.d]="l.d" [attr.fill]="l.fill"
          [attr.transform]="l.transform || null" fill-rule="nonzero"></path>

    <!-- the dawn mist the strip hands off to the tab bar with -->
    <path [attr.d]="fuMistD" [attr.fill]="'url(#' + uid + '-fumist)'"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'etna'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-etsky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="124">
      <stop offset="0" [attr.stop-color]="etSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="etSkyLow"></stop>
    </linearGradient>
    <!-- The lava field. Its LAST stop is the tab bar's own fill. The ramp finishes
         at y=148, not 150: the bottom ROW is y=149 and is sampled at its centre,
         so a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-etground'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="122" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="etGroundTop"></stop>
      <stop offset="1" [attr.stop-color]="etGroundLow"></stop>
    </linearGradient>
    <filter [attr.id]="uid + '-etsoft'" x="-20%" y="-60%" width="140%" height="220%">
      <feGaussianBlur stdDeviation="12"></feGaussianBlur>
    </filter>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-etsky)'"></rect>

    <circle *ngFor="let s of etStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
            fill="#D5CFCF" [attr.opacity]="s.o"></circle>

    <!-- the eruption's light and the plume, BLURRED into the sky rather than drawn
         on it — sharp, the glow is a coloured dome parked on the summit -->
    <g [attr.filter]="'url(#' + uid + '-etsoft)'">
      <path *ngFor="let g of etGlow" [attr.d]="g.d" [attr.fill]="g.fill"
            [attr.opacity]="g.o"></path>
      <path *ngFor="let p of etPlume" [attr.d]="p.d" fill="#B3AEAE"
            [attr.opacity]="p.o"></path>
    </g>

    <!-- the ridges and the cones, then everything hot on them -->
    <path *ngFor="let r of etRock" [attr.d]="r.d" [attr.fill]="r.fill"
          [attr.transform]="r.transform || null" fill-rule="nonzero"></path>
    <path *ngFor="let h of etHot" [attr.d]="h.d" [attr.fill]="h.fill"
          [attr.transform]="h.transform || null" [attr.opacity]="h.o || null"
          fill-rule="nonzero"></path>

    <!-- embers thrown off the crater -->
    <path *ngFor="let e of etEmbers" [attr.d]="e.d" [attr.fill]="e.fill"
          [attr.transform]="e.transform" [attr.opacity]="e.o"
          fill-rule="nonzero"></path>

    <!-- the lava field the strip hands off to the tab bar with, and the light
         still in its joints -->
    <path [attr.d]="etGroundD" [attr.fill]="'url(#' + uid + '-etground)'"></path>
    <path *ngFor="let c of etCracks" [attr.d]="c.d" fill="#D74C57"
          [attr.opacity]="c.o"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'madrid'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-masky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="92">
      <stop offset="0" [attr.stop-color]="maSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="maSkyLow"></stop>
    </linearGradient>
    <!-- The street. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-mastreet'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="128" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="maStreetTop"></stop>
      <stop offset="1" [attr.stop-color]="maStreetLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-masky)'"></rect>

    <!-- the facades and the domes, then every window and balcony in one path -->
    <path *ngFor="let b of maBlocks" [attr.d]="b.d" [attr.fill]="b.fill"
          [attr.transform]="b.transform || null" fill-rule="nonzero"></path>
    <path [attr.d]="maWindowD" [attr.fill]="maWindowFill" opacity="0.62"></path>

    <!-- the street the strip hands off to the tab bar with -->
    <path [attr.d]="maStreetD" [attr.fill]="'url(#' + uid + '-mastreet)'"></path>
  </g>
</svg>

<!-- Vienna: a SHEET OF MUSIC, and the paper it is printed on is the tab bar's own
     fill, so the strip runs into the bar with nothing between them.

     This replaced the inside of the opera house. That scene was a dark room — three
     tiers of boxes, a proscenium and the stalls — and it could not survive the skin
     the owner actually picked, whose tab bar is near-white: a dark band under a
     white bar is the one thing a menu background must never be. It also could not
     be read. At the size this image is actually shown, 360 by 36 CSS pixels, the
     tiers came out as ruled lines with tick marks, the proscenium as a black hole
     and the chandelier as a smudge.

     A staff is the answer to all three at once. It grounds on the paper, it is
     built from the only mark that survives extreme vertical compression — the long
     horizontal line — and it tiles by construction, because a line that runs the
     full width has no ends to match. -->
<svg class="menu-bg" *ngIf="design === 'vienna'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <!-- the paper -->
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="viPaper"></rect>

    <!-- the staff: five lines, each running the full width -->
    <path [attr.d]="viStaffD" [attr.fill]="viRule"></path>

    <!-- bar lines, at uneven intervals -->
    <path [attr.d]="viBarsD" [attr.fill]="viRule"></path>

    <!-- the notes, each in its own tint -->
    <path *ngFor="let n of viNotes" [attr.d]="n.d" [attr.fill]="n.fill"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'spring'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-spsky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="96">
      <stop offset="0" [attr.stop-color]="spSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="spSkyLow"></stop>
    </linearGradient>
    <!-- The foreground haze. Its LAST stop is the tab bar's own fill. The ramp
         finishes at y=148, not 150: the bottom ROW is y=149 and is sampled at its
         centre, so a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-sphaze'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="128" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="spHazeTop" stop-opacity="0"></stop>
      <stop offset="1" [attr.stop-color]="spHazeLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-spsky)'"></rect>

    <path *ngFor="let c of spClouds" [attr.d]="c.d" fill="#FFFFFF"
          [attr.opacity]="c.o"></path>

    <!-- the range, then the sward it stands on -->
    <path *ngFor="let h of spHills" [attr.d]="h.d" [attr.fill]="h.fill"></path>
    <path *ngFor="let s of spSward" [attr.d]="s.d" [attr.fill]="s.fill"></path>

    <!-- blades, then the flower spikes over them, then the bird in the air -->
    <path *ngFor="let b of spBlades" [attr.d]="b.d" [attr.fill]="b.fill"></path>
    <path *ngFor="let s of spSpikes" [attr.d]="s.d" [attr.fill]="s.fill"
          fill-rule="nonzero"></path>
    <path [attr.d]="spBirdD" [attr.fill]="spBirdFill"
          [attr.transform]="spBirdTransform" fill-rule="nonzero"></path>

    <!-- the sunlit haze the strip hands off to the tab bar with -->
    <path [attr.d]="spHazeD" [attr.fill]="'url(#' + uid + '-sphaze)'"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'reynisfjara'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-resky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="96">
      <stop offset="0" [attr.stop-color]="reSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="reSkyLow"></stop>
    </linearGradient>
    <!-- the last light, fading up out of the horizon -->
    <linearGradient [attr.id]="uid + '-reglow'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="66" x2="0" y2="98">
      <!-- WARM. It was #C3B9AD, which is the theme's Bone — a cool grey, and the
           one place the warmth of this scene had to live. A dusk lit by a cold
           grey is not moody, it is bleak, and bleak is the note the owner caught
           on this theme. -->
      <stop offset="0" stop-color="#C5A98F" stop-opacity="0"></stop>
      <stop offset="0.6" stop-color="#C5A98F" stop-opacity="0.34"></stop>
      <stop offset="1" stop-color="#E2C7A6" stop-opacity="0.78"></stop>
    </linearGradient>
    <!-- The sand. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-resand'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="118" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="reSandTop"></stop>
      <stop offset="1" [attr.stop-color]="reSandLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-resky)'"></rect>
    <path [attr.d]="reGlowD" [attr.fill]="'url(#' + uid + '-reglow)'"></path>

    <!-- the sea, then the rock standing in and behind it -->
    <path [attr.d]="reSeaD" [attr.fill]="reSeaFill"></path>
    <path *ngFor="let r of reRock" [attr.d]="r.d" [attr.fill]="r.fill"
          [attr.transform]="r.transform || null" fill-rule="nonzero"></path>

    <!-- surf running up the beach, then the black sand, then the wet sheen on it -->
    <path *ngFor="let s of reSurf" [attr.d]="s.d" fill="#E4E7EA"
          [attr.opacity]="s.o"></path>
    <path [attr.d]="reSandD" [attr.fill]="'url(#' + uid + '-resand)'"></path>
    <path *ngFor="let w of reWet" [attr.d]="w.d" fill="#C3B9AD"
          [attr.opacity]="w.o"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'sydney'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-sysky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="104">
      <stop offset="0" [attr.stop-color]="sySkyTop"></stop>
      <stop offset="1" [attr.stop-color]="sySkyLow"></stop>
    </linearGradient>
    <!-- The harbour. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-sywater'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="104" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="syWaterTop"></stop>
      <stop offset="1" [attr.stop-color]="syWaterLow"></stop>
    </linearGradient>
    <!-- The Opera House's shells. Deliberately in the DEFAULT objectBoundingBox
         units rather than userSpaceOnUse: one definition then gives every shell
         its own gradient across its own bounding box, which is what "each one
         individually" asks for. In user space they would all share one ramp
         spanning the whole strip and the fan would come out flat. -->
    <linearGradient [attr.id]="uid + '-syshell'" x1="0" y1="0" x2="0.55" y2="1">
      <stop offset="0" [attr.stop-color]="syShellTop"></stop>
      <stop offset="1" [attr.stop-color]="syShellLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-sysky)'"></rect>

    <!-- the green headland behind the city -->
    <path [attr.d]="syLandD" [attr.fill]="syLandFill"></path>

    <!-- the city, then the landmarks over it (they are pushed on last) -->
    <path *ngFor="let c of syCity" [attr.d]="c.d" [attr.fill]="c.fill"
          [attr.transform]="c.transform || null" fill-rule="nonzero"></path>

    <!-- the harbour, and the icon's own flat ripples on it -->
    <path [attr.d]="syWaterD" [attr.fill]="'url(#' + uid + '-sywater)'"></path>
    <path *ngFor="let r of syRipples" [attr.d]="r.d" fill="#FFFFFF"
          [attr.opacity]="r.o"></path>

    <!-- boats float ON the water, so they are painted after it -->
    <path *ngFor="let b of syOnWater" [attr.d]="b.d" [attr.fill]="b.fill"
          [attr.transform]="b.transform || null" fill-rule="nonzero"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'prague'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-pgsky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="118">
      <stop offset="0" [attr.stop-color]="pgSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="pgSkyLow"></stop>
    </linearGradient>
    <!-- The river. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-pgriver'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="118" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="pgRiverTop"></stop>
      <stop offset="1" [attr.stop-color]="pgRiverLow"></stop>
    </linearGradient>
    <radialGradient [attr.id]="uid + '-pglamp'">
      <stop offset="0" stop-color="#EFBA5A" stop-opacity="0.42"></stop>
      <stop offset="1" stop-color="#EFBA5A" stop-opacity="0"></stop>
    </radialGradient>
    <radialGradient [attr.id]="uid + '-pgmoon'">
      <stop offset="0" stop-color="#FFF6DC" stop-opacity="0.32"></stop>
      <stop offset="1" stop-color="#FFF6DC" stop-opacity="0"></stop>
    </radialGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-pgsky)'"></rect>

    <circle *ngFor="let s of pgStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
            fill="#DCE7F2" [attr.opacity]="s.o"></circle>

    <!-- the moon, with its halo under it -->
    <circle [attr.cx]="pgMoonX" [attr.cy]="pgMoonY" [attr.r]="pgMoonR * 3"
            [attr.fill]="'url(#' + uid + '-pgmoon)'"></circle>
    <circle [attr.cx]="pgMoonX" [attr.cy]="pgMoonY" [attr.r]="pgMoonR" fill="#F6E7B8"></circle>

    <!-- clouds crossing it -->
    <path *ngFor="let c of pgClouds" [attr.d]="c.d" fill="#8FA9C6"
          [attr.opacity]="c.o"></path>

    <!-- the town: dark masonry, then the lit faces, then every window -->
    <path *ngFor="let m of pgMasonry" [attr.d]="m.d" [attr.fill]="m.fill"
          [attr.transform]="m.transform || null" fill-rule="nonzero"></path>
    <path *ngFor="let l of pgLit" [attr.d]="l.d" [attr.fill]="l.fill"></path>
    <path [attr.d]="pgWindowD" [attr.fill]="pgWindowFill" opacity="0.92"></path>

    <!-- the tree line along the bank, then the river under it -->
    <path [attr.d]="pgTreeD" [attr.fill]="pgTreeFill"></path>
    <path [attr.d]="pgRiverD" [attr.fill]="'url(#' + uid + '-pgriver)'"></path>

    <!-- The street lamps, on their own layer IN FRONT of the terrace: on the
         masonry layer their posts were buried by the house faces and only the
         lanterns showed, which read as glowing chimneys. Each halo is a RADIAL
         GRADIENT — filled flat it is a hard disc parked behind the lamp. -->
    <circle *ngFor="let l of pgLamps" [attr.cx]="l.cx" [attr.cy]="l.cy"
            [attr.r]="l.r" [attr.fill]="'url(#' + uid + '-pglamp)'"></circle>
    <path *ngFor="let l of pgLamps" [attr.d]="l.iron" [attr.fill]="l.ironFill"
          [attr.transform]="l.transform" fill-rule="nonzero"></path>
    <path *ngFor="let l of pgLamps" [attr.d]="l.glass" [attr.fill]="l.glassFill"
          [attr.transform]="l.transform" fill-rule="nonzero"></path>

    <path *ngFor="let g of pgGlints" [attr.d]="g.d" fill="#E3CA77"
          [attr.opacity]="g.o"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'salda'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-sasky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="52">
      <stop offset="0" [attr.stop-color]="saSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="saSkyLow"></stop>
    </linearGradient>
    <!-- The beach. Its LAST stop is the tab bar's own fill. The ramp finishes at
         y=148, not 150: the bottom ROW is y=149 and is sampled at its centre, so
         a ramp ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-sasand'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="120" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="saSandTop"></stop>
      <stop offset="1" [attr.stop-color]="saSandLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-sasky)'"></rect>

    <!-- the far range, back rank first -->
    <path *ngFor="let h of saHills" [attr.d]="h.d" [attr.fill]="h.fill"></path>

    <!-- the water: horizon band first, each one laid over the last -->
    <path *ngFor="let w of saWater" [attr.d]="w.d" [attr.fill]="w.fill"></path>

    <!-- the shoals sit IN the water, with the shallows washing over their lower
         edge — that overlay is what makes them sand rather than stickers -->
    <path *ngFor="let i of saIslands" [attr.d]="i.d" [attr.fill]="i.fill"></path>
    <path *ngFor="let w of saWaterFront" [attr.d]="w.d" [attr.fill]="w.fill"
          [attr.opacity]="w.o"></path>

    <path *ngFor="let f of saFoam" [attr.d]="f.d" fill="#FFFFFF"
          [attr.opacity]="f.o"></path>

    <!-- the beach, then what is lying on it -->
    <path [attr.d]="saSandD" [attr.fill]="'url(#' + uid + '-sasand)'"></path>
    <path *ngFor="let s of saShore" [attr.d]="s.d" [attr.fill]="s.fill"
          [attr.transform]="s.transform || null" fill-rule="nonzero"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'ocean'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <!-- The water. Darkest at the TOP, the reverse of a sky: this looks across a
         seabed rather than up at one, so the light is down on the floor. -->
    <linearGradient [attr.id]="uid + '-ocwater'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="120">
      <stop offset="0" [attr.stop-color]="ocSkyTop"></stop>
      <stop offset="0.58" [attr.stop-color]="ocSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="ocSkyLow"></stop>
    </linearGradient>
    <!-- The floor. Its LAST stop is the tab bar's own fill, so the strip ends on
         exactly the colour LINE paints below it. The ramp finishes at y=148, not
         150: the bottom ROW is y=149 and is sampled at its centre, so a ramp
         ending at 150 never quite reaches its last stop. -->
    <linearGradient [attr.id]="uid + '-ocfloor'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="114" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="ocFloorTop"></stop>
      <stop offset="1" [attr.stop-color]="ocFloorLow"></stop>
    </linearGradient>
    <filter [attr.id]="uid + '-occur'" x="-10%" y="-60%" width="120%" height="220%">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ocwater)'"></rect>

    <!-- the currents, blurred into the water rather than drawn on it -->
    <g [attr.filter]="'url(#' + uid + '-occur)'">
      <path *ngFor="let c of ocCurrents" [attr.d]="c.d" [attr.fill]="c.fill"
            [attr.opacity]="c.o"></path>
    </g>

    <!-- bubbles rise BEHIND the garden, so a column can pass behind a coral -->
    <circle *ngFor="let b of ocBubbles" [attr.cx]="b.cx" [attr.cy]="b.cy" [attr.r]="b.r"
            fill="#CFF3EA" [attr.opacity]="b.o"></circle>

    <!-- seagrass (back rank then front), the tube sponges standing among it,
         then the coral heads over both -->
    <path *ngFor="let g of ocGrass" [attr.d]="g.d" [attr.fill]="g.fill"
          [attr.opacity]="g.o"></path>
    <path *ngFor="let s of ocSponges" [attr.d]="s.d" [attr.fill]="s.fill"></path>
    <path *ngFor="let c of ocCorals" [attr.d]="c.d" [attr.fill]="c.fill"
          fill-rule="nonzero"></path>

    <!-- the lit floor the garden stands in, and what rests on it. The floor is
         painted OVER the garden's roots on purpose, so the starfish drawn after
         it are lying on the shelf rather than buried in it. -->
    <path [attr.d]="ocFloorD" [attr.fill]="'url(#' + uid + '-ocfloor)'"></path>
    <path [attr.d]="ocPebblesD" [attr.fill]="ocPebbleFill" opacity="0.7"></path>
    <path *ngFor="let s of ocStars" [attr.d]="s.d" [attr.fill]="s.fill"></path>

    <!-- the clownfish last: they are IN the water, in front of everything -->
    <path *ngFor="let fp of ocFish" [attr.d]="fp.d" [attr.fill]="fp.fill"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'tallinn'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-tasky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="118">
      <stop offset="0" [attr.stop-color]="taSkyTop"></stop>
      <stop offset="0.6" [attr.stop-color]="taSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="taSkyLow"></stop>
    </linearGradient>
    <!--
      The street. Its LAST stop is the tab bar's own fill, so the strip ends on
      exactly the colour LINE paints below it. The ramp finishes at y=148, not
      150: the bottom ROW is y=149 and is sampled at its centre, so a ramp ending
      at 150 never quite reaches its last stop.
    -->
    <linearGradient [attr.id]="uid + '-taground'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="116" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="taGroundTop"></stop>
      <stop offset="1" [attr.stop-color]="taGroundLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-tasky)'"></rect>

    <!-- the town behind the town, flat and pale (empty on the wall build) -->
    <path *ngIf="taBackD" [attr.d]="taBackD" [attr.fill]="taBackFill"></path>

    <!-- walls, then the red roofs over them, then every scrap of settled snow,
         then the windows -->
    <path *ngFor="let w of taWalls" [attr.d]="w.d" [attr.fill]="w.fill"></path>
    <path *ngFor="let r of taRoofs" [attr.d]="r.d" [attr.fill]="r.fill"></path>
    <path [attr.d]="taSnowD" [attr.fill]="taSnowFill"></path>
    <path [attr.d]="taWindowD" [attr.fill]="taWindowFill" opacity="0.85"></path>

    <!-- the snow the town stands in -->
    <path [attr.d]="taGroundD" [attr.fill]="'url(#' + uid + '-taground)'"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'rio'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-risky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="104">
      <stop offset="0" [attr.stop-color]="riSkyTop"></stop>
      <stop offset="0.62" [attr.stop-color]="riSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="riSkyLow"></stop>
    </linearGradient>
    <radialGradient [attr.id]="uid + '-riglow'">
      <stop offset="0" [attr.stop-color]="riGlowFill" stop-opacity="0.5"></stop>
      <stop offset="1" [attr.stop-color]="riGlowFill" stop-opacity="0"></stop>
    </radialGradient>
    <!--
      The bay. Its LAST stop is the tab bar's own fill, so the strip ends on
      exactly the colour LINE paints below it and the 150px edge disappears. The
      ramp finishes at y=148, not 150: the bottom ROW is y=149 and is sampled at
      its centre, so a ramp ending at 150 never quite reaches its last stop.
    -->
    <linearGradient [attr.id]="uid + '-riwater'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="104" x2="0" y2="134">
      <stop offset="0" [attr.stop-color]="riWaterTop"></stop>
      <stop offset="1" [attr.stop-color]="riWaterLow"></stop>
    </linearGradient>
    <linearGradient [attr.id]="uid + '-rishore'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="127" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="riShoreTop"></stop>
      <stop offset="1" [attr.stop-color]="riShoreLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-risky)'"></rect>

    <!-- the sun just up, and the warmth around it. The glow is a radial GRADIENT
         rather than a blur filter: a blur that reached an edge would fade there
         and bake a dark stripe into every tile seam. -->
    <circle [attr.cx]="riSun.cx" [attr.cy]="riSun.cy" [attr.r]="riSun.r * 4.2"
            [attr.fill]="'url(#' + uid + '-riglow)'"></circle>
    <circle [attr.cx]="riSun.cx" [attr.cy]="riSun.cy" [attr.r]="riSun.r"
            [attr.fill]="riSunFill" opacity="0.92"></circle>

    <!-- the morros, back to front: far haze, middle range, then the Sugarloaf
         group standing forward -->
    <path *ngFor="let h of riHills" [attr.d]="h.d" [attr.fill]="h.fill"></path>

    <!-- the haze along the waterline, which swallows every foot -->
    <path [attr.d]="riMistD" [attr.fill]="riMistFill" opacity="0.85"></path>

    <!-- the bay, then the light on it -->
    <path [attr.d]="riWaterD" [attr.fill]="'url(#' + uid + '-riwater)'"></path>
    <path *ngFor="let s of riShimmer" [attr.d]="s.d" [attr.fill]="riShimmerFill"
          [attr.opacity]="s.o"></path>

    <!-- the near shore, and the last thing in the strip: its ramp ends on the tab
         bar's own fill at y=148 (the bottom ROW is y=149 and is sampled at its
         centre, so a ramp ending at 150 never quite reaches its last stop) -->
    <path [attr.d]="riShoreD" [attr.fill]="'url(#' + uid + '-rishore)'"></path>
  </g>
</svg>

<svg class="menu-bg" *ngIf="design === 'tepui'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-rosky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="126">
      <stop offset="0" [attr.stop-color]="roSkyTop"></stop>
      <stop offset="0.72" [attr.stop-color]="roSkyMid"></stop>
      <stop offset="1" [attr.stop-color]="roSkyLow"></stop>
    </linearGradient>
    <radialGradient [attr.id]="uid + '-roglow'">
      <stop offset="0" [attr.stop-color]="roGlowFill" stop-opacity="0.55"></stop>
      <stop offset="1" [attr.stop-color]="roGlowFill" stop-opacity="0"></stop>
    </radialGradient>
    <!--
      The near bank. Its LAST stop is the tab bar's own fill, so the strip ends
      on exactly the colour LINE paints below it and the 150px edge disappears.
      The ramp finishes at y=148, not 150: the bottom ROW is y=149 and is sampled
      at its centre, so a ramp ending at 150 never quite reaches its last stop and
      the exported row came out a digit off the bar's colour.
    -->
    <linearGradient [attr.id]="uid + '-roground'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="128" x2="0" y2="148">
      <stop offset="0" [attr.stop-color]="roGroundTop"></stop>
      <stop offset="1" [attr.stop-color]="roGroundLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-rosky)'"></rect>

    <!-- the sun going down, and the warmth around it. The glow is a radial
         GRADIENT rather than a blur filter: a blur that reached an edge would
         fade there and bake a dark stripe into every tile seam. -->
    <circle [attr.cx]="roSun.cx" [attr.cy]="roSun.cy" [attr.r]="roSun.r * 3.6"
            [attr.fill]="'url(#' + uid + '-roglow)'"></circle>
    <circle [attr.cx]="roSun.cx" [attr.cy]="roSun.cy" [attr.r]="roSun.r"
            [attr.fill]="roSunFill" opacity="0.9"></circle>

    <!-- stars, up where the sky is empty -->
    <circle *ngFor="let s of roStars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
            [attr.fill]="s.fill" [attr.opacity]="s.o"></circle>

    <!--
      The range. Each mesa is its own generated silhouette (roMesa) rather than
      the theme's traced tepui placed nine times, which stamped one recognisable
      outline across the whole strip.
    -->
    <path *ngFor="let w of roWalls" [attr.d]="w.d" [attr.fill]="w.fill"></path>

    <!-- the haze the range stands in, then a scatter of small trees in it, then
         the near bank. The trees sit between the two haze layers so the front
         one half-swallows them, which is what puts them IN the mist rather than
         on top of it. -->
    <path [attr.d]="roMistD" [attr.fill]="roMistFill" opacity="0.92"></path>
    <g *ngFor="let t of roTrees" fill="none" [attr.stroke]="t.fill" stroke-linecap="round">
      <path [attr.d]="t.trunk" [attr.stroke-width]="t.sw"></path>
      <path [attr.d]="t.fronds" [attr.stroke-width]="t.sw * 0.85"></path>
    </g>
    <path [attr.d]="roMistD2" [attr.fill]="roMistFill2" opacity="0.8"></path>
    <path [attr.d]="roGroundD" [attr.fill]="'url(#' + uid + '-roground)'"></path>
  </g>
</svg>

<!--
  SEQUOIA (kawaii "forest"): Tokyo's skyline logic in a redwood grove — flat tree
  silhouettes in three receding rows along the bottom, stars over the canopy and
  a few warm fireflies among the trunks, on a sky that lands on the tab bar's own
  colour so the strip melts into it. Same top-transparency mask (clear above
  y=16, solid by y=46) and tiling rules as the others.
-->
<svg class="menu-bg" *ngIf="design === 'forest'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <!-- The turn to the tab bar's green happens LOW: the glyphs sit around
         y=30..110, so the strip stays pale there and only the last stretch
         hands off to the fill below. -->
    <linearGradient [attr.id]="uid + '-seqsky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="seqSkyTop"></stop>
      <stop offset="0.62" stop-color="#E8F1DC"></stop>
      <stop offset="1" [attr.stop-color]="seqSkyLow"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-seqsky)'"></rect>

    <circle *ngFor="let s of seqStars" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            fill="#E7EEDF" [attr.opacity]="s.o"></circle>

    <!-- three rows of redwoods, far to near -->
    <path *ngFor="let r of seqRows" [attr.d]="r.d" [attr.fill]="r.fill" [attr.opacity]="r.o"></path>

    <!-- fireflies among the trunks -->
    <circle *ngFor="let f of seqFireflies" [attr.cx]="f.x" [attr.cy]="f.y" [attr.r]="f.r"
            fill="#C9E58A" [attr.opacity]="f.o"></circle>

    <path [attr.d]="seqGroundD" [attr.fill]="seqGroundFill"></path>
  </g>
</svg>

<!--
  AURORA (kawaii "arctic"): the same cute register as Sakura / Tokyo / Everest —
  flat shapes and thick rounded strokes instead of atmospheric gradients. A round
  moon and dot stars over chunky round-capped aurora ribbons, on rolling snow
  hills. The FRONT hill is the tab bar's own near-black, so only its white crest
  draws the silhouette and the strip melts into the bar. Same top-transparency
  mask (clear above y=16, solid by y=46) and tiling rules as the others.
-->
<svg class="menu-bg" *ngIf="design === 'arctic'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-ausky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="auSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="auSkyLow"></stop>
    </linearGradient>
    <!-- The band's colour sweep. Both ends carry the same colour as their
         neighbour, and the band has zero width there anyway, so the tile seam
         can never show a colour step. -->
    <!-- One gradient per curtain colour: solid at the horizon, gone by the top.
         The fade, not the outline, is what makes a flat shape read as light. -->
    <linearGradient *ngFor="let c of auCurtainColors; let i = index"
                    [attr.id]="uid + '-aucur' + i" gradientUnits="userSpaceOnUse"
                    x1="0" y1="132" x2="0" y2="26">
      <stop offset="0" [attr.stop-color]="c" stop-opacity="0.58"></stop>
      <stop offset="0.45" [attr.stop-color]="c" stop-opacity="0.4"></stop>
      <stop offset="1" [attr.stop-color]="c" stop-opacity="0"></stop>
    </linearGradient>
    <!-- Soft edges: without it the curtains read as cut paper, not light. -->
    <filter [attr.id]="uid + '-aublur'" x="-40%" y="-30%" width="180%" height="160%">
      <feGaussianBlur stdDeviation="6"></feGaussianBlur>
    </filter>
    <linearGradient [attr.id]="uid + '-auglow'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="150" x2="0" y2="104">
      <stop offset="0" [attr.stop-color]="auCurtainColors[0]" stop-opacity="0.28"></stop>
      <stop offset="1" [attr.stop-color]="auCurtainColors[2] || auCurtainColors[0]" stop-opacity="0"></stop>
    </linearGradient>
  </defs>

  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ausky)'"></rect>

    <!-- stars -->
    <circle *ngFor="let s of auStars" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            fill="#FFFFFF" [attr.opacity]="s.o"></circle>

    <!-- the lights: horizontal wavy bands, layered and blurred so they read as
         light passing behind the tab glyphs rather than as drawn shapes -->
    <g [attr.filter]="'url(#' + uid + '-aublur)'">
      <path *ngFor="let b of auBands" [attr.d]="b.d" [attr.fill]="b.fill" [attr.opacity]="b.o"></path>
    </g>

    <!-- four-point sparkles -->
    <path *ngFor="let s of auSparkles" [attr.d]="s.d" [attr.fill]="s.fill" [attr.opacity]="s.o"></path>

    <!-- hills: back hump, tiny pines, then the front hill in the tab-bar black
         with a white crest riding its edge -->
    <path [attr.d]="auHillBackD" [attr.fill]="auHillBackFill"></path>
    <path *ngFor="let t of auPines" [attr.d]="t.d" fill="#0B1A22" [attr.opacity]="t.o"></path>
    <path [attr.d]="auHillFrontD" [attr.fill]="auHillFrontFill"></path>
    <!-- No crest highlight and no snow caps: see buildArctic — the ground stays
         bare so the tab glyphs have nothing to collide with. -->
  </g>
</svg>

<!--
  EVEREST (kawaii): a cloudy, Japanese-cute daylight panorama — pastel icy sky,
  soft peach sunrise band, a Fuji-silhouette Everest with a scalloped snowcap,
  hazy sister peaks, puffy cluster clouds, tiny sparkles, rolling snow plain.
  Same top-transparency mask + tiling rules as the aurora design.
-->
<svg class="menu-bg" *ngIf="design === 'everest'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>

    <!-- Pastel icy daylight sky. -->
    <linearGradient [attr.id]="uid + '-sky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="evSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="evSkyLow"></stop>
    </linearGradient>

    <!-- Soft sunrise band (edge stops equal so the strip tiles). -->
    <linearGradient [attr.id]="uid + '-peach'" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" [attr.stop-color]="evPeach" stop-opacity="0.12"></stop>
      <stop offset="0.35" [attr.stop-color]="evPeach" stop-opacity="0.30"></stop>
      <stop offset="0.62" [attr.stop-color]="evPeach" stop-opacity="0.20"></stop>
      <stop offset="1" [attr.stop-color]="evPeach" stop-opacity="0.12"></stop>
    </linearGradient>

    <filter [attr.id]="uid + '-soft'" x="-30%" y="-120%" width="160%" height="340%">
      <feGaussianBlur stdDeviation="10"></feGaussianBlur>
    </filter>
  </defs>

  <!-- Sky + sunrise + the hazy distance, under the top-transparency mask. -->
  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="16" [attr.width]="W" [attr.height]="H - 16" [attr.fill]="'url(#' + uid + '-sky)'"></rect>
    <rect x="0" y="86" [attr.width]="W" height="36"
          [attr.fill]="'url(#' + uid + '-peach)'" [attr.filter]="'url(#' + uid + '-soft)'"></rect>

    <!-- Distant clouds drift behind the peaks. -->
    <ng-container *ngFor="let c of evClouds">
      <g *ngIf="!c.front" [attr.opacity]="c.o" fill="#FFFFFF">
        <circle *ngFor="let k of c.circles" [attr.cx]="k.cx" [attr.cy]="k.cy" [attr.r]="k.r"></circle>
      </g>
    </ng-container>

    <!-- Hazy sister peaks. -->
    <path *ngFor="let pk of evPeaks" [attr.d]="pk.d" [attr.fill]="pk.fill" [attr.fill-opacity]="pk.o"></path>
  </g>

  <!-- The cute Everest + its scalloped snowcap. -->
  <path [attr.d]="evMainD" [attr.fill]="evMainFill"></path>
  <path [attr.d]="evCapD" fill="#FFFFFF"></path>

  <!-- Near clouds float in front of the peaks. -->
  <ng-container *ngFor="let c of evClouds">
    <g *ngIf="c.front" [attr.opacity]="c.o" fill="#FFFFFF">
      <circle *ngFor="let k of c.circles" [attr.cx]="k.cx" [attr.cy]="k.cy" [attr.r]="k.r"></circle>
    </g>
  </ng-container>

  <!-- Tiny sparkles. -->
  <path *ngFor="let s of evSparkles" [attr.d]="s.d" [attr.fill]="s.fill" [attr.fill-opacity]="s.o"></path>

  <!-- Rolling snow plain grounding the tab icons. -->
  <path [attr.d]="evGroundD" [attr.fill]="evGroundFill"></path>
  <rect x="0" y="140" [attr.width]="W" height="10" [attr.fill]="evPlainFill"></rect>
</svg>

<!--
  SAKURA (kawaii): a soft cherry-blossom park — pastel pink sky, a rosy horizon
  glow, puffy clouds, a big blossoming sakura tree (a layered pink puff canopy
  with peeking leaves + accent dots on a warm trunk), hazy blossom bushes, a
  gentle green hill, drifting petals, five-petal blossoms and tiny sparkles.
  Same top-transparency mask + tiling rules as the other designs.
-->
<svg class="menu-bg" *ngIf="design === 'sakura'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>

    <!-- Soft pink daylight sky, fading to EXACTLY the tab-fill colour (skLow =
         #FFE0E7) at the very bottom, so the strip blends into the fill below. -->
    <linearGradient [attr.id]="uid + '-sky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="16" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="skTop"></stop>
      <stop offset="1" [attr.stop-color]="skLow"></stop>
    </linearGradient>

    <!-- Soft rose horizon glow (edge stops equal so the strip tiles). -->
    <linearGradient [attr.id]="uid + '-haze'" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" [attr.stop-color]="skHaze" stop-opacity="0.10"></stop>
      <stop offset="0.35" [attr.stop-color]="skHaze" stop-opacity="0.26"></stop>
      <stop offset="0.62" [attr.stop-color]="skHaze" stop-opacity="0.18"></stop>
      <stop offset="1" [attr.stop-color]="skHaze" stop-opacity="0.10"></stop>
    </linearGradient>

    <filter [attr.id]="uid + '-soft'" x="-30%" y="-120%" width="160%" height="340%">
      <feGaussianBlur stdDeviation="10"></feGaussianBlur>
    </filter>
  </defs>

  <!-- Sky + horizon glow + distance, under the top-transparency mask. -->
  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="16" [attr.width]="W" [attr.height]="H - 16" [attr.fill]="'url(#' + uid + '-sky)'"></rect>
    <rect x="0" y="86" [attr.width]="W" height="36"
          [attr.fill]="'url(#' + uid + '-haze)'" [attr.filter]="'url(#' + uid + '-soft)'"></rect>

    <!-- Puffy clouds drifting high. -->
    <g *ngFor="let c of skClouds" [attr.opacity]="c.o" fill="#FFFFFF">
      <circle *ngFor="let k of c.circles" [attr.cx]="k.cx" [attr.cy]="k.cy" [attr.r]="k.r"></circle>
    </g>

    <!-- Hazy blossom bushes along the hillside. -->
    <g *ngFor="let b of skBushes" [attr.opacity]="b.o" [attr.fill]="b.fill">
      <circle *ngFor="let k of b.circles" [attr.cx]="k.cx" [attr.cy]="k.cy" [attr.r]="k.r"></circle>
    </g>
  </g>

  <!-- No ground band and no bottom rect (owner 2026-07-29): the sky gradient
       already fades to the tab-fill colour at the very bottom, so the strip
       blends straight into the fill below. -->

  <!-- Hero sakura tree: branches, trunk, then the layered pink puff canopy. -->
  <path [attr.d]="skBranchD" fill="none" [attr.stroke]="skTrunkFill"
        stroke-width="3" stroke-linecap="round"></path>
  <path [attr.d]="skTrunkD" [attr.fill]="skTrunkFill"></path>
  <circle *ngFor="let c of skCanopy" [attr.cx]="c.cx" [attr.cy]="c.cy" [attr.r]="c.r"
          [attr.fill]="c.fill" [attr.fill-opacity]="c.o"></circle>
  <circle *ngFor="let l of skLeaves" [attr.cx]="l.cx" [attr.cy]="l.cy" [attr.r]="l.r"
          [attr.fill]="skLeafFill"></circle>
  <circle *ngFor="let d of skDots" [attr.cx]="d.cx" [attr.cy]="d.cy" [attr.r]="d.r"
          [attr.fill]="skDotFill" fill-opacity="0.7"></circle>

  <!-- Five-petal blossoms floating (petals rotated around each blossom centre). -->
  <g *ngFor="let b of skBlossoms"
     [attr.transform]="'translate(' + b.cx + ',' + b.cy + ') scale(' + b.s + ')'"
     [attr.opacity]="b.o">
    <path *ngFor="let tf of b.petalTransforms" [attr.d]="petalD"
          [attr.transform]="tf" [attr.fill]="b.petalFill"></path>
    <circle r="1.6" [attr.fill]="b.centerFill"></circle>
  </g>

  <!-- Drifting cherry-blossom petals. -->
  <path *ngFor="let p of skPetals" [attr.d]="petalD" [attr.transform]="p.transform"
        [attr.fill]="p.fill" [attr.fill-opacity]="p.o"></path>

  <!-- Tiny sparkles. -->
  <path *ngFor="let s of skSparkles" [attr.d]="s.d" [attr.fill]="s.fill" [attr.fill-opacity]="s.o"></path>
</svg>

<!-- Tokyo: a SIMPLE twilight scene (like Sakura's soft sky). Plum→lavender sky
     whose bottom == the tab-fill; the top fades gradually to transparent; one
     subtle skyline whose bases blend into the lavender (bottom-fade mask), a soft
     moon and a few stars. Part of the whole, not a busy illustration. -->
<svg class="menu-bg" *ngIf="design === 'tokyo'"
     [attr.viewBox]="'0 0 ' + W + ' ' + H"
     preserveAspectRatio="none"
     xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradual TOP transparency: fully transparent at the top edge, opaque by
         y46, so the strip melts into whatever sits above it. LINE spec
         (Images 1.1) requires the BOTTOM 100px to be fully opaque, so on a
         150px strip the ramp must finish at or above y=50; y=46 keeps a few px
         of margin for renderer antialiasing. -->
    <linearGradient [attr.id]="uid + '-ramp'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="0" x2="0" y2="46">
      <stop offset="0" stop-color="#ffffff" stop-opacity="0"></stop>
      <stop offset="1" stop-color="#ffffff" stop-opacity="1"></stop>
    </linearGradient>
    <mask [attr.id]="uid + '-skym'">
      <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-ramp)'"></rect>
    </mask>
    <linearGradient [attr.id]="uid + '-sky'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="0" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="tkSkyTop"></stop>
      <stop offset="1" [attr.stop-color]="tkSkyLow"></stop>
    </linearGradient>
    <!-- Ground / road band below the skyline; melts into the tab-fill lavender. -->
    <linearGradient [attr.id]="uid + '-ground'" gradientUnits="userSpaceOnUse"
                    x1="0" y1="122" x2="0" y2="150">
      <stop offset="0" [attr.stop-color]="tkGroundTop"></stop>
      <stop offset="1" [attr.stop-color]="tkSkyLow"></stop>
    </linearGradient>
    <filter [attr.id]="uid + '-moon'" x="-120%" y="-120%" width="340%" height="340%">
      <feGaussianBlur stdDeviation="8"></feGaussianBlur>
    </filter>
  </defs>

  <!-- Sky + stars + moon, under the top-transparency mask. -->
  <g [attr.mask]="'url(#' + uid + '-skym)'">
    <rect x="0" y="0" [attr.width]="W" [attr.height]="H" [attr.fill]="'url(#' + uid + '-sky)'"></rect>
    <circle *ngFor="let s of tkStars" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            fill="#FFFFFF" [attr.fill-opacity]="s.o"></circle>
    <circle [attr.cx]="tkMoon.cx" [attr.cy]="tkMoon.cy" [attr.r]="tkMoon.r * 1.9"
            fill="#F4E9F7" fill-opacity="0.16" [attr.filter]="'url(#' + uid + '-moon)'"></circle>
    <circle [attr.cx]="tkMoon.cx" [attr.cy]="tkMoon.cy" [attr.r]="tkMoon.r" fill="#F1E6F4"></circle>
    <circle [attr.cx]="tkMoon.cx + 6" [attr.cy]="tkMoon.cy - 4" [attr.r]="tkMoon.r * 0.9"
            [attr.fill]="tkSkyTop" fill-opacity="0.55"></circle>
  </g>

  <!-- Ground / road strip, then the varied skyline standing on it. -->
  <rect x="0" y="122" [attr.width]="W" height="28" [attr.fill]="'url(#' + uid + '-ground)'"></rect>
  <g>
    <path *ngFor="let b of tkBuildings" [attr.d]="b.d" [attr.fill]="b.fill"></path>
    <rect *ngFor="let w of tkWindows" [attr.x]="w.x" [attr.y]="w.y" [attr.width]="w.s"
          [attr.height]="w.s" rx="0.6" [attr.fill]="w.fill" [attr.fill-opacity]="w.o"></rect>
  </g>
</svg>
